<div class="plaid-error-alert col-md-6 col-sm-12">
  <div class="alert-header">
    <mat-icon class="alert-icon">error_outline</mat-icon>
    <h4 class="alert-title">Connection Issue</h4>
  </div>
  
  <div class="alert-body">
    <p class="alert-message">
      We're having trouble connecting to your bank through Plaid. You can try again or use our manual bank form instead.
    </p>
  </div>
  
  <div class="alert-actions">
    <button mat-stroked-button (click)="onRetry()" class="btn btn-custom btn-continue-primary retry-btn">
      <mat-icon>refresh</mat-icon>
      Try Again
    </button>
    <button mat-raised-button (click)="onManualEntry()" class="btn btn-custom btn-continue manual-btn">
      <mat-icon>account_balance</mat-icon>
      Manual Bank Form
    </button>
  </div>
</div>
